export default __webpack_public_path__ + "static/underline-26-024cd852f756cb73a96ad25241840552.svg";